export const openFile = fileID => {
    return window.open(`/api/manager/files/${fileID}/preview`, '_blank');
};

export const getFileThumbnailUrl = fileID => {
    return `/api/manager/files/${fileID}/thumbnail`;
};

export const getLeaseAttachmentUrl = (portal, fileID, type, leaseID, contactID) => {
    return `/api/${portal}/lease/files/${fileID}/${type}?leaseID=${leaseID}&portalID=${contactID}`;
};

export const downloadFile = downloadFileApi => {
    return new Promise((resolve, reject) => {
        downloadFileApi
            .then(response => {
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.setAttribute('href', url);
                link.setAttribute('download', response.headers['rentvine-filename']);

                document.body.appendChild(link);
                link.click();

                link.parentNode.removeChild(link);

                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export const isPath = data => data && 'path' in data && 'pathID' in data;

export const isVideoFile = fileObject => {
    const videoMimeTypes = ['mp4', 'webm', 'ogg', 'mpeg'];

    return videoMimeTypes.includes(fileObject.file.fileType);
};

export const isAudioFile = fileObject => {
    const audioMimeTypes = ['mp3', 'wav', 'ogg', 'aac', 'm4a', 'flac'];

    return audioMimeTypes.includes(fileObject.file.fileType);
};

// isPDF
export const isPDF = fileObject => {
    const pdfMimeTypes = ['pdf'];

    return pdfMimeTypes.includes(fileObject.file.fileType);
};

export const getFileIcon = data => {
    if (isPath(data)) return 'folder';
    else if (isVideoFile(data)) return 'video_camera_front';
    else if (isAudioFile(data)) return 'audio_file';
    else if (isPDF(data)) return 'picture_as_pdf';
    else return 'article';
};
